import {
  CollectionAndUserCheck,
  CollectionAndUserCheckFromJSON,
  CopyRegisterLendAndReturnConditionRequest,
  CopyRegisterLendAndReturnConditionRequestToJSON,
  CopyRegisterReserveConditionRequest,
  CopyRegisterReserveConditionRequestToJSON,
  CreateCollectionAndUserCheckRequest,
  CreateCollectionAndUserCheckRequestToJSON,
  CreateLendAndReturnConditionRequest,
  CreateLendAndReturnConditionRequestToJSON,
  CreateReserveConditionRequest,
  CreateReserveConditionRequestToJSON,
  GetCollectionAndUserCheckRequest,
  GetCollectionAndUserCheckRequestToJSON,
  GetLendAndReturnConditionRequest,
  GetLendAndReturnConditionRequestToJSON,
  GetReserveConditionRequest,
  GetReserveConditionRequestToJSON,
  HTTPBody,
  HTTPQuery,
  LendAndReturnCondition,
  LendAndReturnConditionFromJSON,
  ReserveCondition,
  ReserveConditionFromJSON,
  UpdateCollectionAndUserCheckRequest,
  UpdateCollectionAndUserCheckRequestToJSON,
  UpdateLendAndReturnConditionRequest,
  UpdateLendAndReturnConditionRequestToJSON,
  UpdateReserveConditionRequest,
  UpdateReserveConditionRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class ConditionApi extends runtime.BaseAPI {
  /**
   * 予約条件を取得する
   * 予約条件取得
   */
  async getReserveCondition(
    request: GetReserveConditionRequest
  ): Promise<ReserveCondition> {
    const queryParameters: runtime.HTTPQuery = GetReserveConditionRequestToJSON(
      request
    )
    const response = await this.requestGet(
      '/conditions/reserve',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ReserveConditionFromJSON(jsonValue)
    ).value()
  }

  /**
   * 予約条件を更新する
   * 予約条件更新
   */
  async updateReserveCondition(
    request: UpdateReserveConditionRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateReserveConditionRequestToJSON(
      request
    )
    const response = await this.requestPut(
      '/conditions/reserve',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 予約条件を作成する
   * 予約条件作成
   */
  async createReserveCondition(
    request: CreateReserveConditionRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = CreateReserveConditionRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/conditions/reserve',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 予約条件を複写する
   * 予約条件複写
   */
  async copyRegisterReserveCondition(
    request: CopyRegisterReserveConditionRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = CopyRegisterReserveConditionRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/conditions/reserve/duplicate',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 資料・利用者チェックを取得する
   * 資料・利用者チェック取得
   */
  async getCollectionAndUserCheck(
    request: GetCollectionAndUserCheckRequest
  ): Promise<CollectionAndUserCheck> {
    const queryParameters: HTTPQuery = Object.fromEntries(
      Object.entries(GetCollectionAndUserCheckRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestGet(
      '/conditions/collection-and-user',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      CollectionAndUserCheckFromJSON(jsonValue)
    ).value()
  }

  /**
   * 資料・利用者チェックを更新する
   * 資料・利用者チェック更新
   */
  async updateCollectionAndUserCheck(
    request: UpdateCollectionAndUserCheckRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateCollectionAndUserCheckRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/conditions/collections-and-user/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 資料・利用者チェックを作成する
   * 資料・利用者チェック作成
   */
  async createCollectionAndUserCheck(
    request: CreateCollectionAndUserCheckRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = CreateCollectionAndUserCheckRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/conditions/collection-and-user',
      bodyParameters
    )
    return new runtime.VoidApiResponse(response)
  }

  /**
   * 貸出・返却条件を取得する
   * 貸出・返却条件取得
   */
  async getLendAndReturnCondition(
    request: GetLendAndReturnConditionRequest
  ): Promise<LendAndReturnCondition> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetLendAndReturnConditionRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      '/conditions/lend-and-return',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      LendAndReturnConditionFromJSON(jsonValue)
    ).value()
  }

  /**
   * 貸出・返却条件を更新する
   * 貸出・返却条件更新
   */
  async updateLendAndReturnCondition(
    request: UpdateLendAndReturnConditionRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateLendAndReturnConditionRequestToJSON(
      request
    )

    const response = await this.requestPut(
      '/conditions/lend-and-return',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 貸出・返却条件を作成する
   * 貸出・返却条件作成
   */
  async createLendAndReturnCondition(
    request: CreateLendAndReturnConditionRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = CreateLendAndReturnConditionRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/conditions/lend-and-return',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 貸出・返却条件を複写する
   * 貸出・返却条件複写
   */
  async copyRegisterLendAndReturnCondition(
    request: CopyRegisterLendAndReturnConditionRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = CopyRegisterLendAndReturnConditionRequestToJSON(
      request
    )

    const response = await this.requestPost(
      '/conditions/lend-and-return/duplicate',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
